package com.example.mystybag.appCore.model.pages

import com.example.mystybag.sharedmodels.project.responseModels.merchant.BagProductSelectionMode
import com.example.mystybag.sharedmodels.project.responseModels.merchant.MerchantLocationResponseModel
import com.example.mystybag.sharedmodels.project.responseModels.merchant.ProductCategoryModel
import com.example.mystybag.sharedmodels.project.responseModels.merchant.ProductModel
import kotlinx.datetime.LocalDate

data class AddBagUIState(
    val merchantLocationId: Long,
    val availableLocations: List<MerchantLocationResponseModel> = emptyList(),
    /** Optional display title for the bag. */
    val title: String = "",
    val businessCategoryId: Long? = null,
    val bagId: Long? = null,
    val isEditMode: Boolean = false,
    val isEnabled: Boolean = true,
    val activeFrom: LocalDate? = null,
    val activeTo: LocalDate? = null,
    val activeToError: String = "",
    /** Time range when order can be picked up (HH:mm). Shown under Active from/to. */
    val pickupTimeFrom: String = "",
    val pickupTimeTo: String = "",
    val bagsCount: String = "",
    val priceNormal: String = "",
    val discountPercentageInput: String = "30",
    /** In edit mode: loaded from server, shown in "Цена с отстъпка" field. */
    val priceWithDiscountLoaded: String? = null,
    val priceNormalError: String = "",
    val discountPercentageError: String = "",
    /** Incremented when price field gains focus so the View moves cursor to end. */
    val movePriceCursorToEndTrigger: Int = 0,
    val currency: String = "EUR",
    val isLoading: Boolean = false,
    // Products
    val availableProductCategories: List<ProductCategoryModel> = emptyList(),
    val availableProducts: List<ProductModel> = emptyList(),
    val isLoadingProducts: Boolean = false,
    /** How the bag's products are chosen (all / by category / custom). */
    val productSelectionMode: BagProductSelectionMode = BagProductSelectionMode.ALL,
    /** Selected categories when [productSelectionMode] == CATEGORY (supports multiple). */
    val selectedProductCategoryIds: Set<Long> = emptySet(),
    /** Selected products when [productSelectionMode] == CUSTOM. */
    val selectedProductIds: Set<Long> = emptySet(),
    /** Merchant-declared flag: bag may contain products for persons over 18. */
    val containsProductsForPersonsOver18: Boolean = false,
    /** Free-text filter applied to products in CUSTOM mode. */
    val productSearchQuery: String = "",
    val requiredFieldErrors: Set<AddBagRequiredField> = emptySet(),
    val validationTargetTab: AddBagSectionTab? = null,
    val validationTargetField: AddBagRequiredField? = null,
    val validationRequestId: Int = 0
)

enum class AddBagSectionTab {
    DETAILS,
    PRICE,
    COLLECT_TIME,
    PRODUCTS
}

enum class AddBagRequiredField {
    LOCATION,
    TITLE,
    ACTIVE_FROM,
    ACTIVE_TO,
    PICKUP_TIME_FROM,
    PICKUP_TIME_TO,
    BAGS_COUNT,
    PRICE_NORMAL,
    DISCOUNT_PERCENTAGE
}

